import React, { useEffect } from 'react'
import parse, { domToReact } from "html-react-parser";
import axios from 'axios';
import {
    useQuery,
} from 'react-query';
import moment from 'moment';
import { Row, Col } from "react-flexbox-grid";
import upperCase from 'lodash/upperCase';
import { Facebook, Twitter } from "react-sharingbuttons";
import { nourishMonthlyChallenge } from '../../helpers/api';

import { TransitionEaseInOne } from "../common/transitions";
import LeftArrow from '../images/longArrowLeft.png';
import RightArrow from '../images/longArrowRight.png';
import FilesIcon from '../images/filesIcon.png';
import "../styles/common.scss";


const renderMarkdownContent = (content) => {
    if (content) {
        return parse(content, {
            replace: (attribs, children) => {
                if (attribs.id === "a") {
                    return (
                        <a target="_blank">{domToReact(children, { depth: null })}</a>
                    );
                }
                if (attribs.name === "blockquote") {
                    return (
                        <div className="sharewrapper">
                            <ul className="SocialLink">
                                <li>
                                    <Twitter
                                        // text={`Share on Twitter`}
                                        url={replace(
                                            window.location.href,
                                            "http://localhost:8080",
                                            "https://dashingdish.com"
                                        )}
                                        shareText={
                                            attribs.children && attribs.children.length > 0
                                                ? attribs.children[0].data
                                                : ""
                                        }
                                    />
                                </li>
                                <li>
                                    <Facebook
                                        // text={`Share on Facebook`}
                                        url={replace(
                                            window.location.href,
                                            "http://localhost:8080",
                                            "https://dashingdish.com"
                                        )}
                                        shareText={
                                            attribs.children && attribs.children.length > 0
                                                ? attribs.children[0].data
                                                : ""
                                        }
                                    />
                                </li>
                            </ul>
                            <blockquote>
                                {domToReact(attribs.children, { depth: null })}
                            </blockquote>
                        </div>
                    );
                }
            },
        });
    }
};

export const getMonthlyChallenge = async () => {
    const response = await axios.get(nourishMonthlyChallenge.get());
    return response.data.personalized_documents;
}

const MonthlyChallenge = (props) => {
    const { isLoading: monthlyChallengeIsLoading, data: monthlyChallengeData } = useQuery({
        queryKey: ['monthlyChallenge'],
        queryFn: getMonthlyChallenge
    });

    return !monthlyChallengeIsLoading ? (
        <div>
            <TransitionEaseInOne>
                <section className="home-hero katies-corner-hero blog-list-hero" style={{
                    backgroundImage: `url(${monthlyChallengeData[0]?.banner})`,
                }}>
                    <div className='container'>
                        <Row className="home-hero-wrapper home-hero-heading no-margin-sm">
                            <Col xs={12} className="hero-container-row no-padding-sm">
                                <div className="home-hero-text">
                                    <p className='hero-katies-corner-legend'>Monthly Challenge</p>
                                    <h1>
                                        {monthlyChallengeData[0]?.title}
                                    </h1>
                                </div>

                            </Col>
                        </Row>
                    </div>
                </section>
            </TransitionEaseInOne>
            <section className='interiorBlog personalized-blog-interior'>
                <div className='container'>
                    <div className='interiorWrapper personalized-blog-interior-wrapper'>
                        <div className='interiorBlog-content'>
                            {renderMarkdownContent(monthlyChallengeData[0]?.content || '')}
                            {
                                monthlyChallengeData[0]?.attachments?.length > 0 ? (
                                    <div className='blog-attachment-group'>
                                        <h3 className="blog-attachment-header">
                                            Attachments
                                        </h3>
                                        <div className='blog-attachment-container'>
                                            {
                                                monthlyChallengeData[0]?.attachments.map((attachment) => (
                                                    <a href={attachment} target='_blank' className="blog-attachment-item">
                                                        <img src={FilesIcon} />
                                                        <span>{attachment.split('/')[attachment.split('/').length - 1].replaceAll('%20', ' ')}</span>

                                                    </a>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>
                </div>
            </section>

        </div >
    ) : null
}

export default MonthlyChallenge